import { render, staticRenderFns } from "./feesexemptions.vue?vue&type=template&id=370705d7&"
import script from "./feesexemptions.vue?vue&type=script&lang=js&"
export * from "./feesexemptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports